import { useEffect } from 'react';
export function usePageVisibility(onVisibilityChange) {
    useEffect(function () {
        var handleVisibilityChange = function () {
            onVisibilityChange(document.hidden);
        };
        if (typeof document.hidden !== 'undefined') {
            document.addEventListener('visibilitychange', handleVisibilityChange, false);
            return function () {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }
    }, [onVisibilityChange]);
}
//# sourceMappingURL=usePageVisibility.js.map